export default "__VITE_ASSET__004d927a__"